import { useContext } from 'react';
import {
  NotificationsContext,
  type NotificationsContextValue,
} from './notificationsContextValue';

/**
 * Read the shared notifications state (the polled list + the badge counts).
 * Throws if used outside a `NotificationsProvider` (the shell mounts one).
 */
export function useNotifications(): NotificationsContextValue {
  const ctx = useContext(NotificationsContext);
  if (!ctx) throw new Error('useNotifications must be used within a NotificationsProvider');
  return ctx;
}
